(function () {
  var WIDGET_SELECTOR = 'order-protection';
  var MOVED_ATTR = 'data-order-protection-moved';
  var SUBTOTAL_RE = /\b(subtotal|estimated total)\b/i;
  var CHECKOUT_RE = /\bcheckout\b/i;
  var scheduleTimer = null;
  var observer = null;

  function textOf(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    return !!(el && el.getClientRects && el.getClientRects().length);
  }

  function addStyle() {
    if (document.getElementById('op-placement-style')) return;

    var style = document.createElement('style');
    style.id = 'op-placement-style';
    style.textContent =
      WIDGET_SELECTOR +
      '[' +
      MOVED_ATTR +
      '="true"]{display:block;width:100%;max-width:100%;margin:0 0 12px 0;}';
    document.head.appendChild(style);
  }

  function getWidgets() {
    return Array.prototype.slice.call(document.querySelectorAll(WIDGET_SELECTOR)).filter(isVisible);
  }

  function getScope(widget) {
    return (
      widget.closest(
        '.cart-drawer, .cart-drawer__footer, .drawer__footer, .cart__footer, .cart-footer, .cart-summary, #main-cart-footer, form[action*="/cart"], main'
      ) ||
      document.querySelector('main') ||
      document.body
    );
  }

  function targetFromSubtotalText(scope) {
    var nodes = Array.prototype.slice.call(scope.querySelectorAll('*'));
    var best = null;

    nodes.some(function (node) {
      if (node.matches(WIDGET_SELECTOR) || node.closest(WIDGET_SELECTOR)) return false;

      var text = textOf(node);
      if (!SUBTOTAL_RE.test(text)) return false;
      if (CHECKOUT_RE.test(text) && text.length > 80) return false;
      if (text.length > 220) return false;

      best = node;
      return true;
    });

    if (!best) return null;

    while (best.parentElement && best.parentElement !== scope) {
      var parent = best.parentElement;
      var parentText = textOf(parent);

      if (parentText.length > 450) break;
      if (CHECKOUT_RE.test(parentText)) break;
      if (!SUBTOTAL_RE.test(parentText)) break;

      best = parent;
    }

    return best;
  }

  function targetFromSelectors(scope) {
    var selectors = [
      '[data-cart-subtotal]',
      '.cart__subtotal',
      '.cart-subtotal',
      '.cart-drawer__subtotal',
      '.cart-summary__subtotal',
      '.cart__total',
      '.cart-total',
      '.totals',
      '[class*="subtotal" i]',
      '[id*="subtotal" i]',
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      try {
        var el = scope.querySelector(selectors[i]);
        if (el && !el.matches(WIDGET_SELECTOR) && !el.closest(WIDGET_SELECTOR)) {
          return el;
        }
      } catch (e) {}
    }

    return null;
  }

  function getTarget(scope) {
    return targetFromSelectors(scope) || targetFromSubtotalText(scope);
  }

  function placeWidget(widget) {
    var scope = getScope(widget);
    var target = getTarget(scope);

    if (!scope || !target || widget === target || widget.contains(target)) return false;
    if (target.previousElementSibling === widget) return true;

    widget.setAttribute(MOVED_ATTR, 'true');
    target.parentElement.insertBefore(widget, target);
    return true;
  }

  function run() {
    addStyle();
    getWidgets().forEach(placeWidget);
  }

  function schedule(delay) {
    window.clearTimeout(scheduleTimer);
    scheduleTimer = window.setTimeout(run, delay || 100);
  }

  function boot() {
    run();
    [150, 400, 900, 1600, 3000, 5000].forEach(function (delay) {
      window.setTimeout(run, delay);
    });

    if (!observer && document.body) {
      observer = new MutationObserver(function () {
        schedule(150);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('on:cart:change', function () {
      schedule(250);
    });
    document.addEventListener('cart:updated', function () {
      schedule(250);
    });
    document.addEventListener('cart:refresh', function () {
      schedule(250);
    });
    document.addEventListener('change', function () {
      schedule(600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    schedule(300);
  });
})();
